import { FC, useState } from 'react';
import {
  Drawer,
  Button,
  ButtonStyles,
  RadioButton,
  Theme,
  useTranslation,
  ButtonSize,
  ButtonWidth,
} from '@nextgen-web-framework/all';
import { PlanResponse, Cycle } from '@commerce-subscription-webcomponents/sdk';
import styles from './FrequencyDetailsDrawer.module.scss';

export interface FrequencyDetailsDrawerProps {
  plans: PlanResponse[];
  selectedPlan: string;
  showDrawer: (val: boolean) => void;
  updatePlan?: (planId: string, cycle?: Cycle) => void;
}

const FrequencyDetailsDrawer: FC<FrequencyDetailsDrawerProps> = (props: FrequencyDetailsDrawerProps): JSX.Element => {
  const { selectedPlan, plans, showDrawer, updatePlan } = props;
  const [planId, setPlanId] = useState<string>(selectedPlan);
  const [cycle, setCycle] = useState<Cycle>();
  const t = useTranslation();

  const updateSelectedPlan = (planId: string, cycle?: Cycle) => {
    if (updatePlan) {
      updatePlan(planId, cycle);
    }
  };

  return (
    <Drawer
      header={<div>{t('subscription.subscriptionSelection.planDetailsDrawerTitle')}</div>}
      bottomGap={0}
      footer={
        <div className={styles['frequency-drawer']}>
          <Button
            data-testid="cancel-testid"
            title={t('subscription.subscriptionSelection.cancelButtonText')}
            buttonStyle={ButtonStyles.OUTLINE}
            onClick={() => showDrawer(false)}
            size={ButtonSize.MEDIUM}
            buttonWidth={ButtonWidth.FULL_WIDTH}
          />
          <Button
            data-testid="apply-cta-testid"
            title={t('subscription.continue.btnLabel')}
            onClick={() => {
              showDrawer(false);
              updateSelectedPlan(planId, cycle);
            }}
            size={ButtonSize.MEDIUM}
            buttonWidth={ButtonWidth.FULL_WIDTH}
          />
        </div>
      }
      closeIcon={true}
      closeOnBackdropClick={true}
      onClose={() => showDrawer(false)}
      data-testid="subscription-details-drawer-test-id"
      useReactPortal={true}
      portalContainerId="react-portal-drawer"
    >
      <div className={styles['frequency-list']} data-testid="frequency-option-testid">
        {plans.map((plan, index) => {
          const isSelected = plan.id === planId;
          return (
            <div key={plan.id} className={styles['frequency-option-wrapper']}>
              <RadioButton
                data-testid={`plan-${index}`}
                theme={isSelected ? Theme.PURPLE : Theme.GRAY}
                label={
                  isSelected ? (
                    plan?.cycle?.description
                  ) : (
                    <span className={styles['radio-label']}>{plan?.cycle?.description}</span>
                  )
                }
                checked={isSelected}
                onChange={() => {
                  setPlanId(plan.id || '');
                  setCycle(plan.cycle);
                }}
              />
            </div>
          );
        })}
      </div>
    </Drawer>
  );
};

export default FrequencyDetailsDrawer;
